import type { AdminLocalProcessorSettingsResponse } from '@oracord/shared';

export type EngineDisplayTone = 'green' | 'amber' | 'slate';

export interface OracordEngineDisplayState {
  connectionLabel: 'Connected' | 'Not connected';
  connectionTone: EngineDisplayTone;
  readinessLabel: 'Ready' | 'Needs setup';
  readinessTone: EngineDisplayTone;
  versionLabel: string;
  lastSeenLabel: string;
}

export function describeOracordEngineState(
  processor: AdminLocalProcessorSettingsResponse | null,
): OracordEngineDisplayState {
  const engine = processor?.engine;
  const runtime = processor?.components.engineRuntime;
  const connected = Boolean(runtime?.connected && processor?.lastHeartbeatAt);
  const ready = Boolean(connected && runtime?.available && engine?.status === 'ready');

  return {
    connectionLabel: connected ? 'Connected' : 'Not connected',
    connectionTone: connected ? 'green' : 'slate',
    readinessLabel: ready ? 'Ready' : 'Needs setup',
    readinessTone: ready ? 'green' : connected ? 'amber' : 'slate',
    versionLabel: engine?.version ? `Version ${engine.version}` : 'Version pending setup',
    lastSeenLabel: formatEngineLastSeen(processor?.lastHeartbeatAt ?? null),
  };
}

export function formatEngineLastSeen(lastHeartbeatAt: string | null): string {
  if (!lastHeartbeatAt) return 'Last seen pending';
  const date = new Date(lastHeartbeatAt);
  if (Number.isNaN(date.getTime())) return 'Last seen unavailable';

  return `Last seen ${date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })}`;
}
